import { FC, useState } from "react";
import FormCreditCard, { IPaymentMethod } from "./FormCreditCard";
import {
  Modal,
  ModalFoot,
  ModalHead,
  Sizes,
} from "@/components/molecules/modals/Modal";

import { Button } from "@/components/atoms/buttons/Button";
import { accountApi } from "@/apis/accounts/accountApi";
import { useLoading } from "@/states/loading/operations";
import { useStripe } from "@stripe/react-stripe-js";

interface Props {
  handleSubmit: () => Promise<void>;
  isOpen: boolean;
  onClose: () => void;
}

export const ModalChangePaymentMethod: FC<Props> = (props: Props) => {
  const { isOpen, onClose, handleSubmit } = props;

  const stripe = useStripe();
  const withLoading = useLoading();

  const [isError, setIsError] = useState<boolean>(false);

  const onConfirmPaymentMethod = async (paymentMethod: IPaymentMethod) => {
    await withLoading(async () => {
      try {
        const response = await stripe?.createPaymentMethod({
          type: "card",
          card: paymentMethod.card,
          billing_details: paymentMethod.billing_details,
        });
        if (!response || !response.paymentMethod || !response.paymentMethod.id)
          return;
        await accountApi.updateAccountPaymentDefault({
          updateAccountPaymentDefaultRequest: {
            payment_method_id: response.paymentMethod.id,
          },
        });
        await handleSubmit();
        void handleClose();
      } catch (_) {
        setIsError(true);
      }
    });
  };

  const handleClose = () => {
    setIsError(false);
    void onClose();
  };
  return (
    <Modal
      size={Sizes.XXXL}
      handleClose={handleClose}
      isOpen={isOpen}
      containerClassName="!mt-0"
    >
      <ModalHead
        title="支払い方式の変更"
        isShowCloseBtn={false}
        onClickClose={handleClose}
      />
      <div className="px-6 py-4">
        {isError && (
          <div className="inline-flex justify-center items-center mb-4 w-[100%] h-[66px] text-[14px] text-accent rounded border border-accent">
            カードが拒否されました。
          </div>
        )}
        <FormCreditCard
          onUpdatePaymentMethod={onConfirmPaymentMethod}
          showErrorPart={setIsError}
          label="クレジットカード情報の更新"
        />
      </div>
      <ModalFoot className="flex justify-end space-x-4 border-t">
        <Button
          size="md"
          color="bg-white"
          label="キャンセル"
          onClick={handleClose}
        />
        <Button
          size="md"
          type="submit"
          form="register-credit-card-form"
          label="変更する"
        />
      </ModalFoot>
    </Modal>
  );
};
